import React from 'react'
import SingleCarOrHome from './Items.js'
const Buy = () => {
    return (
        <div>
            <SingleCarOrHome/>
        </div>
    )
}

export default Buy
